import { createContext } from 'react';
import type { EntitySecurityContextEntry, FeatureName } from '../../../auth/Security';
import type { SidePanelDeclaration } from '../../types';

export type SidePanelOwnerRegistration = {
    ownerId: string;
    declarations: readonly SidePanelDeclaration[];
    entitySecurityChain: EntitySecurityContextEntry[];
    featureSecurityChain: FeatureName[];
    deepLinkBasePath: string;
};

export type SidePanelOwnerContextValue = SidePanelOwnerRegistration & {
    ownerChain: string[];
    ownerRegistrations: SidePanelOwnerRegistration[];
};

export const SidePanelOwnerContext = createContext<SidePanelOwnerContextValue | null>(null);
